import { render, staticRenderFns } from "./parent.vue?vue&type=template&id=36e09988&scoped=true&"
import script from "./parent.vue?vue&type=script&lang=ts&"
export * from "./parent.vue?vue&type=script&lang=ts&"
import style0 from "./parent.vue?vue&type=style&index=0&id=36e09988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e09988",
  null
  
)

export default component.exports